// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"86dea49e","132":"6c6f7404","337":"5a427599","345":"9f16783c","489":"6149b822","519":"28278f00","650":"f76a2e80","829":"3b8766da","881":"68e71566"}[chunkId] + ".chunk.js";
};